const BASE_URL = process.env.REACT_APP_STATIC_SITE_BASE_URL || "/";
const TRACKING_APP_URL = process.env.REACT_APP_TRACKING_APP_BASE_URL || "/";
const MY_CITYSPRINT_URL = process.env.REACT_APP_MY_CITYSPRINT_BASE_URL || "/";

const bareLinks = {
  HOMEPAGE: "/",

  // courier services
  COURIER_SERVICES: "/courier-services",
  SAME_DAY_DELIVERY: "/courier-services/same-day-delivery",
  NEXT_DAY_DELIVERY: "/courier-services/next-day-delivery",
  INTERNATIONAL_DELIVERY: "/courier-services/international-delivery",
  MULTI_DROP_COURIER: "/courier-services/multi-drop-courier",
  IT_RELOCATION: "/courier-services/it-relocation",
  CONTACT_RUNS: "/courier-services/contract-runs",

  // logistics services
  LOGISTICS_SERVICES: "/courier-services/logistics-services",
  STORAGE_PICK_PACK: "/courier-services/storage-pick-pack",
  FREIGHT_SERVICES: "/courier-services/freight-services",
  IN_NIGHT_DELIVERY: "/courier-services/in-night-delivery",
  REFRIGERATED_VEHICLES: "/courier-services/refrigerated-vehicles",

  // healthcare services
  HEALTHCARE_SERVICES: "/courier-services/healthcare",
  HOSPITAL_LOGISTICS:
    "/courier-services/healthcare/hospital-logistics-and-emergency-care/hospital-logistics",
  BLOOD_AND_ORGAN:
    "/courier-services/healthcare/hospital-logistics-and-emergency-care/blood-transportation",
  CLINICAL_TRIAL: "/courier-services/healthcare/clinical-trials-logistics",
  PATHOLOGY_SOLUTIONS:
    "/courier-services/healthcare/pathology-and-specimen-transportation/specimen-transportation",
  PHARMACY_TO_HOME: "/courier-services/healthcare/pharmacy-to-home",
  WHOLESALER_LOGISTICS:
    "/courier-services/healthcare/pharmaceutical-logistics/wholesaler-logistics-solutions",

  // by industry
  HEALTHCARE: "/courier-services/healthcare",
  RETAIL: "/courier-services/retail",
  PUBLIC_SECTOR: "/courier-services/public-sector",
  FACILITIES_MANAGEMENT: "/courier-services/facilities-management",

  // about citysprint
  ABOUT_US: "/about-us",
  OUR_PEOPLE: "/about-us/our-people",
  OUR_FLEET: "/about-us/our-fleet",
  OUR_CUSTOMERS: "/about-us/our-customers",
  NATIONAL_COVERAGE: "/about-us/nationwide-coverage",

  // helping you grow
  CASE_STUDIES: "/about-us/case-studies",
  TESTIMONIALS: "/about-us/testimonials",
  AWARDS: "/about-us/awards-and-accreditations",
  TECHNOLOGY: "/about-us/technology",
  SELL_YOUR_BUSINESS: "/about-us/sell-your-business",

  // building a better future
  CSR_FOCUS: "/about-us/csr",
  SUSTAINABLE_DELIVERY: "/about-us/csr/building-a-sustainable-future",
  SUPPORTING_LOCAL_COMMUNITIES:
    "/about-us/csr/supporting-our-local-communities",
  EMPOWERING_OUR_PEOPLE: "/about-us/csr/empowering-our-people",
  BACKING_BUSINESS: "/about-us/csr/backing-business",

  // work with us
  CAREERS: "/careers",
  BECOME_A_COURIER: "/couriers",

  // how can we help
  CONTACT_US: "/support/contact-us",
  TRACK_YOUR_ITEMS: TRACKING_APP_URL,
  FIND_YOUR_LOCAL_SERVICE_CENTRE: "/locations",
  REQUEST_AN_ONLINE_PROFILE: "/account/activate-your-online-account",

  // guides & resources
  GUIDES_AND_RESOURCES: "/support/resources",
  HOW_TO_PACKAGE_YOUR_ITEMS: "/support/resources/packaging-guide",
  ALL_ESSENTIAL_RESOURCES: "/support/resources",

  // payments & guidance
  FUEL_SURCHARGES: "/fuel-surcharges",
  GLOBAL_ENERGY_SURCHARGE: "/global-energy-surcharge",
  PAYMENT_OPTIONS: "/payment-options",
  UK_OVERNIGHT: "/ukoi-additional-charges",

  // find your service centre
  LONDON: "/locations/south-east/london-central",
  BIRMINGHAM: "/locations/midlands/birmingham",
  MANCHESTER: "/locations/north/manchester",
  ALL_SERVICE_CENTRES: "/locations",

  // header
  SIGN_UP_FOR_AN_ACCOUNT: `${MY_CITYSPRINT_URL}/s/company-registration`,

  // footer
  COVID_SECURE: "/covid-secure-at-citysprint",

  SUPPORT: "/support",
  INSIGHTS: "/insights",

  NEWS: "/news",
  BLOG: "/blog",

  INDEMNITY_REQUEST: "/indemnity-request",
  PUBLIC_LIABILITY_INSURANCE: "/public-liability-insurance",

  CS_INSTAGRAM: "https://www.instagram.com/citysprintuk",
  CS_TWITTER: "https://twitter.com/CitySprint_UK",
  CS_LINKEDIN: "http://www.linkedin.com/company/citysprint",
  CS_YOUTUBE: "http://www.youtube.com/user/CitySprintUK",

  GDPR: "/gdpr",
  TERMS_AND_CONDITIONS: "/terms-and-conditions",
  COOKIES: "/cookie-policy",
  MODERN_SLAVERY_ACT: "/modern-slavery-act",
  PRIVACY_POLICY: "/privacy-policy",
};

type LinksKey = keyof typeof bareLinks;

export const links = Object.fromEntries(
  Object.entries(bareLinks).map(([key, value]) => [
    key,
    value.startsWith("http") ? value : BASE_URL + value,
  ])
) as { [key in LinksKey]: string };
